export default {
    path: '/fault/faultMsg',
    name: 'FaultMsg',
    component: () => import(/* webpackChunkName: "faultMsg" */ '../../views/fault/components/faultMsg.vue')
}